<template>
  <div>
    <input ref="realInput" class="form-control" :value="dateString" @click="onClickInput" />
    <datetime-picker
      ref="dtp"
      :value="dateString"
      @input="onInput($event)"
      type="date"
      :week-start="7"
      :use12-hour="true"
      input-class="form-control hidden"
    ></datetime-picker>
  </div>
</template>

<script>
import { Datetime as DatetimePicker } from "vue-datetime";

export default {
  components: { DatetimePicker },
  props: ["value"],
  methods: {
    onInput(e) {
      const tzoffsetMinutes = new Date(e).getTimezoneOffset();
      const tzoffsetMs = (tzoffsetMinutes) * 60 * 1000;
      this.$emit("input", new Date(e).getTime() + tzoffsetMs);
    },
    onClickInput(e) {
      this.$refs.dtp.$el.children[0].click();
      this.$refs.realInput.blur();
    },
  },
  computed: {
    dateString() {
      var int = parseInt(this.value);
      if (isNaN(int)) return "";
      // return new Date(int).toISOString();
      const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const date = new Date(int);
      const str = `${
        months[date.getUTCMonth()]
      } ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
      return str;
    },
  },
};
</script>

<style>
.hidden {
  display: none;
}
</style>